import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { BillerList } from './billerlist.model';

@Injectable({
  providedIn: 'root'
})
export class BillerlistService {



  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {


  }


  getAll(categoryId: number, status: number) {
    return this.http.get<BillerList[]>(this.global.APIURLV2 + "efbillerslist/get?categoryId=" +
      categoryId + "&status=" + status);
  }

  getById(id: number) {
    return this.http.get<BillerList>(this.global.APIURLV2 + "efbillerslist/getbyid/" + id);
  }

  Update(billerList: BillerList) {
    return this.http.put(this.global.APIURLV2 + "efbillerslist/update", billerList)
  }
}
